import React from 'react';
import ItemBox from '../ItemBox';
import {problemList} from './list';
import ProblemsList from './ProblemsList';
import {useParams} from 'react-router-dom';
import './Problem.css';

export default function Problem(props) {
  var {name} = useParams(); // If coming from react router.

  return <ItemBox
    {...props}
    className="problem-box"
    preview={props.preview}
    data={props.data}
    list={!props.data ? problemList : null}
    search={(props.name) ? props.name : name}
    propertyName="name"
    alternativesName="alternatives"
    ListComp={ProblemsList}
    previewName="preview"
    textName="text"
  />;
};
